import { initialAdvertsState } from 'redux/initialState';
import { status } from 'constants/general';

import advertsActionTypes from './action-types';

const advertsReducer = (state = initialAdvertsState, { type, payload }) => {
  switch (type) {
    case advertsActionTypes.FETCH_ADVERTS_LIST:
      return {
        ...state,
        advertsList: {
          status: status.FETCHING,
        },
      };

    case advertsActionTypes.FETCH_ADVERTS_LIST_SUCCESS:
      return {
        ...state,
        advertsList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case advertsActionTypes.FETCH_ADVERTS_LIST_FAIL:
      return {
        ...state,
        advertsList: {
          status: status.FAIL,
        },
      };

    case advertsActionTypes.FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION:
      return {
        ...state,
        addOrEditAdvert: {
          status: status.FETCHING,
        },
      };

    case advertsActionTypes.FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION_SUCCESS:
      return {
        ...state,
        addOrEditAdvert: {
          status: status.SUCCESS,
        },
      };

    case advertsActionTypes.FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION_FAIL:
      return {
        ...state,
        addOrEditAdvert: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default advertsReducer;
